import React, { Suspense } from 'react';
import { withRouter, Switch, Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUserRole } from '../../utils/UserDetails';
import UserLayout from '../../layouts/UserLayout';
import PrivateRoute from '../../routers/PrivateRoute';
import PublicRoute from '../../routers/PublicRoute';

const Dashboard = React.lazy(() =>
  import(/* webpackChunkName: "viwes-blank-page" */ './Dashboard')
);

const UnAuthorized = React.lazy(() =>
  import(/* webpackChunkName: "viwes-blank-page" */ './Unauthorized')
);

const OfficeUserList = React.lazy(() =>
  import(/* webpackChunkName: "viwes-blank-page" */ './UserList')
);

const UserList = React.lazy(() =>
  import(/* webpackChunkName: "viwes-blank-page" */ './Users/Profile')
);


const App = ({ match }) => {
  return (
    <div className="dashboard-wrapper">
    <UserLayout>
      <Suspense fallback={<div className="loading" />}>
        <Switch>
          <Redirect
            exact
            from={`${match.url}/`}
            to={
              getUserRole()
                ? `${match.url}/dashboard`
                : `${match.url}/login`
            }
          />

           <PrivateRoute
            exact
            path={`${match.url}/dashboard`}
            component={Dashboard}
            menuId="dashboard"
          />

          
            <PrivateRoute
            exact
            path={`${match.url}/user-list`}
            component={UserList}
            menuId="users.users"
          />

          <PrivateRoute
            exact
            path={`${match.url}/office-user-list`}
            component={OfficeUserList}
            menuId="users.office.users"
          />

          <PublicRoute
            exact
            path={`${match.url}/unauthorized`}
            component={UnAuthorized}
          />

       
        </Switch>
      </Suspense>
    </UserLayout>
    </div>
  );
};



export default withRouter(connect(null, {})(App));